import React, { PropsWithChildren } from 'react';

import { useLocation } from 'react-router-dom';

import Layout from './index';
import LayoutMobile from './LayoutMobile';
import { useIsMobile } from 'utils/mediaQueries';

const LayoutSwitcher: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  const isMobile = useIsMobile();
  const location = useLocation();

  // Lista de rotas públicas que não precisam de layout
  const publicRoutes = ['/login', '/register', '/forgot-password', '/register-iframe'];
  const isPublicRoute = publicRoutes.includes(location.pathname);

  console.log('[LayoutSwitcher] Estado atual:', {
    isMobile,
    currentPath: location.pathname,
    isPublicRoute,
  });

  // Se for rota pública, renderiza sem layout
  if (isPublicRoute) {
    console.log('[LayoutSwitcher] Rota pública, renderizando sem layout');
    return <>{children}</>;
  }

  // Se não for rota pública, aplica o layout apropriado
  console.log('[LayoutSwitcher] Rota privada, aplicando layout:', isMobile ? 'Mobile' : 'Desktop');
  return isMobile ? <LayoutMobile>{children}</LayoutMobile> : <Layout>{children}</Layout>;
};

export default LayoutSwitcher;
